// Slugs that should match exactly
export const STRICT_RESERVED_SLUGS = [
	// Administrative
	"god",
	"admin",
	"administrator",
	"manage",
	"management",
	"sys",
	"system",
	"root",
	"superuser",
	"supervisor",
	"moderator",
	"mod",
	"owner",
	"master",
	"control",
	"controller",
	"access",

	// Authentication
	"auth",
	"login",
	"logout",
	"signin",
	"signout",
	"register",
	"signup",
	"account",
	"password",
	"recover",
	"reset",
	"verify",
	"verification",
	"oauth",
	"sso",
	"mfa",
	"2fa",
	"totp",
	"security-key",
	"webauthn",
	"passkey",
	"session",
	"token",
	"jwt",
	"join",
	"invite",
	"register",
	"signup",
	"login",
	"logout",
	"signin",
	"signout",

	// Common application routes
	"api",
	"app",
	"dashboard",
	"settings",
	"profile",
	"help",
	"support",
	"docs",
	"documentation",
	"portal",
	"console",
	"workspace",
	"projects",
	"teams",
	"users",
	"members",
	"billing",
	"payments",
	"subscriptions",
	"plans",
	"pricing",
	"checkout",
	"cart",
	"store",
	"shop",
	"market",
	"marketplace",
	"inventory",

	// Meta
	"about",
	"contact",
	"privacy",
	"terms",
	"legal",
	"security",
	"feedback",
	"faq",
	"careers",
	"jobs",
	"press",
	"news",
	"announcements",
	"changelog",
	"features",
	"roadmap",
	"brand",
	"branding",
	"guidelines",
	"style",
	"styleguide",
	"design",
	"info",
	"information",

	// Generic
	"home",
	"www",
	"mail",
	"email",
	"blog",
	"status",
	"internal",
	"public",
	"private",
	"default",
	"new",
	"all",
	"group",
	"groups",
	"org",
	"orgs",
	"company",
	"companies",
	"enterprise",
	"business",
	"corporate",
	"corp",
	"inc",
	"llc",
	"ltd",
	"global",
	"international",
	"worldwide",
	"local",
	"official",
	"unofficial",

	// Infrastructure & Technical
	"cdn",
	"dns",
	"mx",
	"smtp",
	"ftp",
	"ssh",
	"vpn",
	"proxy",
	"server",
	"host",
	"cluster",
	"node",
	"instance",
	"registry",
	"repository",
	"repo",
	"database",
	"db",
	"cache",
	"queue",
	"worker",
	"cron",
	"task",
	"assets",

	// Special values
	"undefined",
	"null",
	"nan",
	"void",
	"error",
	"success"
]

// Slugs that should match at the start of the string
export const STARTS_WITH_RESERVED_SLUGS = [
	// Buape Specific
	"orbit-",
	"orbit",
	"kiai-",
	"kiai",
	"buape-",
	"buape",
	"jt99-",
	"jt99",
	"jt-99-",
	"jt-99"
]

export const isReserved = (slug: string) => {
	return (
		STRICT_RESERVED_SLUGS.includes(slug) ||
		STARTS_WITH_RESERVED_SLUGS.some((prefix) => slug.startsWith(prefix))
	)
}
